import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { LayoutComponent } from './layout/layout.component';
import { ModalChangePasswordComponent } from './login/components/modal-change-password/modal-change-password.component';
import { ChangePasswordComponent } from './login/components/modals/change-password/change-password.component';
import { ForgotPasswordComponent } from './login/containers/forgot-password/forgot-password.component';
import { LoginComponent } from './login/containers/login/login.component';
import { ModalRolesComponent } from './login/containers/modal-roles/modal-roles.component';
import { UpdatePasswordComponent } from './login/containers/update-password/update-password.component';
import { ViewProfileComponent } from './login/containers/view-profile/view-profile.component';
import { AuthInterceptor } from './login/interceptors/auth.interceptor';
import { ErrorInterceptor } from './login/interceptors/error.interceptor';
import { SharedModule } from './shared/shared.module';
import { effects } from './store/effects';
import { metaReducers, reducers } from './store/reducers';
import { NewTokenInterceptor } from './login/interceptors/new-token.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    UpdatePasswordComponent,
    ModalRolesComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ViewProfileComponent,
    ChangePasswordComponent,
    ModalChangePasswordComponent,
    LayoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production
    }),
    HttpClientModule,
    ReactiveFormsModule,
    CoreModule,
    SharedModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: NewTokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
